<script lang="ts">
    import { onMount } from "svelte"
    import { colorCodes } from "../../config"
    import PlayCircleOutline from "svelte-material-icons/PlayCircleOutline.svelte"
    import Close from "svelte-material-icons/Close.svelte"
    import VideoJs from "../widgets/VideoJs.svelte"

    export let activeImage: ImageEntry = undefined
    export let product: Product
    export let activeColor: RALColor = undefined

    let oldProduct: Product
    let listContainer: HTMLElement
    $: if (oldProduct !== product) {
        activeImage = undefined
        oldProduct = product
    }

    let playVideo = ""

    function getColorFromImage(image: ImageEntry): RALColor {
        const filename = image?.file?.src
        if (filename) {
            const match = filename.match(/^[^_]+_(\d{4})(_|\.)/)
            if (match && match[1]) {
                const ral = match[1]
                for (let i = 0; i < colorCodes.length; i++) {
                    if (colorCodes[i].RAL == ral) {
                        return colorCodes[i]
                    }
                }
            }
        }
    }

    function setActiveColor(image: ImageEntry) {
        const color = getColorFromImage(image)
        if (color) {
            activeColor = color
        }
    }

    function setImageFromColor(color: RALColor) {
        if (color) {
            // get color from active image and return if same as color
            if (getColorFromImage(activeImage)?.RAL == color.RAL) {
                return
            }

            // find matching image
            for (let i = 0; i < product?.images?.length; i++) {
                if (getColorFromImage(product?.images[i])?.RAL == color.RAL) {
                    if (activeImage != product?.images[i]) {
                        activeImage = product?.images[i]
                    }
                    return
                }
            }
        }
    }
    // Überwacht das Scroll-Verhalten und die Sichtbarkeit des lower-overlay
    onMount(() => {
        const lowerOverlay = document.querySelector(".lower-overlay") as HTMLElement
        const upperOverlay = document.querySelector(".upper-overlay") as HTMLElement
        function setOverlayVisibility() {
            const isAtBottom = listContainer.scrollHeight - listContainer.scrollTop === listContainer.clientHeight
            const isAtTop = listContainer.scrollTop === 0
            if (lowerOverlay) {
                if (isAtBottom) lowerOverlay.style.display = "none"
                else lowerOverlay.style.display = "block"
            }
            if (upperOverlay) {
                if (isAtTop) upperOverlay.style.display = "none"
                else upperOverlay.style.display = "block"
            }
        }
        setOverlayVisibility()
        listContainer.addEventListener("scroll", () => {
            setOverlayVisibility()
        })
    })
    $: setImageFromColor(activeColor)
</script>

<div class="wrapper">
    <ul class="list" bind:this="{listContainer}" class:no-overflow="{product?.images?.length <= 4}">
        {#each product?.images?.length ? product.images : [{ file: { src: "/media/kein-bild.jpg" } }] as image, idx}
            <li class="image" class:active="{activeImage == image || (!activeImage && idx == 0)}">
                {#if image.file?.src?.match(/\.jpe?g|png$/)}
                    <button
                        on:click="{() => {
                            activeImage = image
                            setActiveColor(image)
                        }}"
                    >
                        <img src="{image.file?.src + '?filter=xs'}" alt="" loading="lazy" />
                    </button>
                {:else}
                    <button
                        style="display: flex; align-items: center"
                        on:click="{() => {
                            playVideo = image.file?.src
                        }}"
                    >
                        <PlayCircleOutline size="50" />
                    </button>
                {/if}
            </li>
        {/each}
    </ul>
    <div class="overlay" class:upper-overlay="{product?.images?.length > 4}"></div>
    <div class="overlay" class:lower-overlay="{product?.images?.length > 4}"></div>
</div>

{#if playVideo}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div class="video-overlay" on:click="{() => (playVideo = '')}">
        <div class="container">
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <div class="close" on:click="{() => (playVideo = '')}"><Close size="30" /></div>
            <div class="inner" id="video-wrapper">
                <VideoJs autoplay controls src="{playVideo}" fluid />
            </div>
        </div>
    </div>
{/if}

<style lang="less">
    @import "../../css/variables.less";
    .wrapper {
        @media (min-width: 1200px) {
            max-height: 500px;
        }
        position: relative;
        .overlay {
            position: absolute;
            left: 0;
            width: 100px;
            right: 0;
            height: 100px; /* Höhe des Auslaufeffekts */
            pointer-events: none; /* Ermöglicht das Klicken auf Elemente unter dem Overlay */
            display: none;
        }
        .lower-overlay {
            bottom: 0px;
            background: linear-gradient(
                to bottom,
                rgba(255, 255, 255, 0),
                rgba(255, 255, 255, 1)
            ); /* Beispiel für einen Auslaufeffekt */
        }
        .upper-overlay {
            top: 0px;
            background: linear-gradient(
                to top,
                rgba(255, 255, 255, 0),
                rgba(255, 255, 255, 1)
            ); /* Beispiel für einen Auslaufeffekt */
        }

        ul {
            margin: 0px;
            width: 135px;
            margin-right: 10px;
            max-height: 500px;
            overflow-y: auto;
            &.no-overflow {
                overflow: hidden;
            }
            height: 100%;
            list-style-type: none; /* Removes the bullets or numbers */
            padding: 0;
            padding-bottom: 65px;

            @media (max-width: 1200px) {
                order: 2;
                .flex();
                width: 100%;
                height: auto;
                flex-wrap: wrap;
            }
            li {
                button {
                    border: none;
                    outline: none;
                    background: none;
                    margin: 0;
                    padding: 0;
                    overflow: hidden;
                    width: 100%;
                    height: 100%;
                    padding: 5px;
                    display: flex;
                    justify-content: center;
                    cursor: pointer;
                }
                overflow: hidden;
                width: 100px;

                height: 100px;
                background: var(--surface);
                margin-bottom: 10px;
                flex-shrink: 0;

                border: solid 2px var(--surface);
                .transition();
                cursor: pointer;
                @media (max-width: 1200px) {
                    margin-right: 10px;
                    height: 70px;
                    width: 70px;
                }
                &:hover,
                &.active {
                    border: 1px solid var(--primary);
                }
                img {
                    border: 0px solid black;
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
        }
        @media (max-width: 1200px) {
            .overlay {
                opacity: 0 !important;
            }
            ul {
                padding-bottom: 0px;
            }
        }
    }

    .video-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 3000;
        background: rgba(0, 0, 0, 0.3);
        .transition();
        .flex();
        flex-direction: column;

        .inner {
            position: relative !important;
            height: 100% !important;
            .video-js {
                video {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
        }

        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            padding: 10px;
            cursor: pointer;
            line-height: 1;
            z-index: 3000;
        }
    }
</style>
